<template>
<section>
  <div>
    <b-container v-if="wastelessProducts && wastelessProducts.length">
      <b-row class="mt-3">
        <b-col cols="7">
          <div class="wasteless_card_50" @click="$router.push({path:'/wasteless/?discount=50'})">
          <div class="mt-4">PRODUTOS COM ATÉ</div>
          <div class="wasteless_big_price">50%</div>
          <div class="wasteless_big_off">OFF</div>
          </div>
        </b-col>
        <b-col cols="5" style="padding-left:0px">
          <b-row>
            <b-col cols="12">
              <div class="wasteless_card_30" @click="$router.push({path:'/wasteless/?discount=30'})">
                <div>PRODUTOS COM ATÉ</div>
                <div class="wasteless_big_price">30%</div>
                <div class="wasteless_big_off">OFF</div>
              </div>
            </b-col>
            <b-col cols="12 mt-2">
              <div class="wasteless_card_15" @click="$router.push({path:'/wasteless/?discount=15'})">
                <div>PRODUTOS COM ATÉ</div>
                <div class="wasteless_big_price">15%</div>
                <div class="wasteless_big_off">OFF</div>
              </div>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
    <template v-for="(productList, idxPl) in productsList">
      <div v-if="!productList.type || productList.type === 'CUSTOM_LIST' " v-bind:key="idxPl" style="margin:10px 5px; z-index:9000;" >
        <div class="labelName">
            {{productList.name}}
        </div>
        <div :class="{
          productsHorizontal: $mq === 'mobile' || $mq === 'tablet',
          'row': $mq !== 'mobile' && $mq !== 'tablet'
          }">

          <!-- produtos -->
          <template v-for="(p, idx) in productList.products">
            <div
            v-bind:key="idx"
            v-if="p.product && !p.product.expires_at"
            :class="{
            productsContainer: $mq === 'mobile' || $mq === 'tablet',
            'col-4 col-xl-3': $mq !== 'mobile' && $mq !== 'tablet'
            }"
            >
              <div class="product">
                <div class="imgContainer"
                @click="$router.push({path:'/product/'+p.product.id})"
                style="cursor:pointer;position:relative;">
                  <AtacarejoSticker style="right:8px;bottom:0px;" :productView='p.product.product_views[0]'/>
                  <img @error="imgUrlAlt" v-if="p.product.photos.length" :alt="p.product.name" :src="productImageURI + '/' + p.product.photos[0].id" />
                  <img v-else :alt="p.product.name" src="https://cdnimages.opa4.store/img/fixedimg/no-picture.png" />
                  <div v-if="!p.product.has_presentation && p.product.product_views[0].promotional_price" class="promoLabel" :style="{backgroundColor: getCssColor('primary_bt')}">
                    {{ Math.round((100 - ((p.product.product_views[0].promotional_price / p.product.product_views[0].price) * 100)))}}% OFF
                  </div>
                </div>
                <div class="productName">
                  {{p.product.name.toLowerCase()}}
                </div>
                <div class="productFooter">
                  <div class="priceContainer">
                    <template v-if="!p.product.has_presentation">
                      <div v-if="p.product.product_views[0].promotional_price" class="productFrom" style="margin-top:3px;">R$ {{formatPrice(p.product.product_views[0].price)}}</div>
                      <div v-if="!p.product.product_views[0].promotional_price" class="productPrice" :style="{color: getCssColor('primary_bt')}"> R$ {{formatPrice(p.product.product_views[0].price)}} </div>
                      <div v-else-if="p.product.product_views[0].promotional_price" class="productPrice" :style="{color: getCssColor('primary_bt')}"> R$ {{formatPrice(p.product.product_views[0].promotional_price)}} </div>
                    </template>
                    <template v-else>
                      <div class="productFrom" style="margin-top:3px;text-decoration:none;">a partir</div>
                      <div class="productPrice" :style="{color: getCssColor('primary_bt')}"> R$ {{formatPrice(getMinorViewPrice(p.product.product_views))}} </div>
                    </template>
                  </div>
                  <div class="buttonContainer"  v-if="!p.product.has_presentation && !isOnCart(p.id, p.product.product_views[0].id)">
                    <div @click="addToCart(p.product, p.product.product_views[0].id)" class="addToCart" :style="{backgroundColor: getCssColor('primary_bt')}">
                      COMPRAR
                    </div>
                  </div>
                  <div class="buttonContainer"  v-else-if="p.product.has_presentation">
                    <div class="addToCart" @click="$router.push({path:'/product/'+p.product.id})" :style="{borderColor: getCssColor('primary_bt'), color: getCssColor('primary_bt')}">
                      ESCOLHA
                    </div>
                  </div>
                  <div v-else class="plusConatiner" style="display:inline-flex;line-height:46px;">
                    <div class="plus-bt" @click="minusQtd(p.product.id, p.product.product_views[0].id)">
                      <font-awesome-icon v-if="getQtd(p.product.id, p.product.product_views[0].id) > 1" style="cursor:pointer;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'minus-circle']"/>
                      <font-awesome-icon v-else style="cursor:pointer;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'trash-alt']"/>
                    </div>
                    <div class="plus-qtd" style="text-align:center;">{{getQtd(p.product.id, p.product.product_views[0].id)}}</div>
                    <div class="plus-bt" @click="plusQtd(p.product.id, p.product.product_views[0].id)"><font-awesome-icon style="cursor:pointer;"  :style="{color: getCssColor('primary_bt')}" :icon="['fas', 'plus-circle']"/></div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <!-- /produtos -->
        </div>
      </div>
    </template>
    <div style="display:flex;width:100%;justify-content: center;flex-wrap:wrap" class="mb-3 mt-2">
    <template v-for="(productList2, idxPl) in productsList">
      <div v-if="productList2.type === 'CUSTOM_CARD'" v-bind:key="idxPl" style="margin:10px 5px; z-index:9000;text-align:center">
        <img @click="$router.push({path:'/cards/?products='+productList2.products.map(p => p.id) + '&name=' + productList2.name})" :src="'https://cdnimages.opa4.store/img/' + $store.getters.getChoiceCompanyId + '/list/' + productList2.photo" style="wisth:100%;cursor:pointer;"/>
      </div>
    </template>
    </div>
  </div>
</section>
</template>

<script>
import cartMixin from '@/mixins/cartMixin'
import formaters from '@/mixins/formaters'
import colors from '@/mixins/colors'
import ProductsConn from '@/connection/productsv2.js'
import AtacarejoSticker from '@/components/AtacarejoSticker'

export default {
  name: 'PromotionsSections',
  data () {
    return {
      productsList: [],
      products: [],
      wastelessProducts: null
    }
  },

  mixins: [colors, formaters, cartMixin],

  components: {AtacarejoSticker},

  computed: {
    productImageURI () {
      return this.$store.getters.getProductImageURI
    }
  },

  async created () {
    let vm = this
    this.wastelessProducts = await ProductsConn.getWastelessProducts()
    ProductsConn.getAllProductList()
      .then((result) => {
        vm.productsList = result.data
      })
      .catch((e) => {
        console.log('error ', {e}.reponse.status)
      })
  },

  methods: {
    
  }

}
</script>

<style lang="scss" scoped>
@import "@/css/_variables.scss";

.wasteless_card_50 {
  width:100%;
  height:100%;
  background: url('https://cdnimages.opa4.store/img/fixedimg/wasteless_card_bg.png'), linear-gradient(225.32deg, #D1283D 9.42%, #FF445C 88.58%) ;
  border-radius: 21px;
  padding:20px;
  font-family: 'Nunito-Black';
  font-size: 12px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.03em;
  color: #FFFFFF;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  font-weight:bold;
  cursor: pointer;
  .wasteless_big_price {
    font-size:54px;
     margin: -15px 0;
  }
  .wasteless_big_off {
    font-size:24px;
  }
}

.wasteless_card_30 {
  width:100%;
  height:100%;
  background: url('https://cdnimages.opa4.store/img/fixedimg/wasteless_card_bg.png'), linear-gradient(222.46deg, #651C72 7.86%, #852F94 94.57%);
  border-radius: 21px;
  padding:10px;
  font-family: 'Nunito-Black';
  font-size: 10px;
  align-items: center;
  text-align: center;
  letter-spacing: -0.03em;
  color: #FFFFFF;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  font-weight:bold;
  cursor: pointer;
  .wasteless_big_price {
    font-size:44px;
    margin: -15px 0;
  }
  .wasteless_big_off {
    font-size:16px;
  }
}

.wasteless_card_15 {
  width:100%;
  height:100%;
  background: url('https://cdnimages.opa4.store/img/fixedimg/wasteless_card_bg.png'), linear-gradient(222.46deg, #659A35 7.86%, #7DB34C 70.18%);
  border-radius: 21px;
  padding:10px;
  font-family: 'Nunito-Black';
  font-size: 10px;
  text-align: center;
  letter-spacing: -0.03em;
  color: #FFFFFF;
  text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  font-weight:bold;
  cursor: pointer;
  align-items: center;
  .wasteless_big_price {
    font-size:44px;
     margin: -15px 0;
  }
  .wasteless_big_off {
    font-size:16px;
  }
}

.labelName {
  color:#2C2A29; 
  font-size:20px;
  padding:20px;
  font-weight: 500;

  @media screen and (min-width: $tablet) {
    font-size:40px;
    line-height:40px;
    text-align:center;
  }
}



.imgIcon {
  font-size: 48px;
  color: rgb(172, 170, 169);
}

.productsHorizontal {
  width:100%;
  height:310px;
  overflow-x:auto;
  -webkit-overflow-scrolling: touch;
  overflow-y:hidden;
  padding:5px;
  display:flex;

  .product:last-child {
    margin-right:15px;
  }

  .product {
    // border-top: 0;
    // border-right: 1px  solid;
    // border-bottom: 1px solid;
    // border-left: 0px;
    // border-color: #DAD7D4;
    border-radius:4px;
    width: 200px;
    height: 300px;
    margin: 0;
    //box-shadow: 1px 1px 2px #DAD7D4;
    box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.15);
    //border: 1px solid #DAD7D4;
    background-color:#ffffff;

    img {
      max-width:167px!important;
      max-height:167px!important;
      // border-radius:4px 4px 0 0;
      border: 0px;
      margin-top:10px;
    }

    .imgContainer {
      width:200px!important;
      height:167px!important;
      border-radius:4px 4px 0 0;
      border: 0px;
      text-align: center;
      line-height: 167px;
      vertical-align: middle;
      margin:0 auto;
      z-index:1!important;
      position:relative;
    }

    .productName {
      color: #312922;
      font-size: 14px;
      font-weight: 500;
      padding: 0 5px;
      height:57px;
      width:180px;
      overflow: hidden;
      overflow-wrap: break-word;
      text-overflow: ellipsis;
      margin-top:13px;
      text-align:center;
      text-transform: capitalize;
    }

    .productFrom {
      font-size: 16px;
      color: rgb(99, 96, 92);
      padding:0 5px;
      text-decoration: line-through;
      height:23px;
      min-width:160px;
    }

    .productPrice {
      font-size: 18px;
      font-weight: 500;
      padding: 0 5px;
      position:absolute;
      bottom: 0;
    }

    .addToCart {
      min-width: 70px;
      text-align:center;
      border:1px solid;
      padding:5px 7px 5px 5px;;
      border-radius:4px;
      font-size:11px;
      font-weight:500;
      color:#ffffff;
      margin-top:20px;
      cursor:pointer;

    }

    .productFooter {
      display:flex; margin-top:3px;height:46px;
    }

    .priceContainer {
      width:120px;
      line-height:24px;
      height:48px;
      vertical-align: bottom;
      position:relative;
    }

    .buttonContainer {
      width:60px;
    }

    .plusConatiner {
      margin: 12px auto;
      text-align:center;
      .plus-bt {
        font-size:20px;
      }
      .plus-qtd {
        font-size:14px;
        width:30px;
        font-weight: 500;
      }
    }
  }

  .promoLabel {
    border-radius:4px;
    height:24px;
    width:74px;
    position:absolute;
    top:5px;
    left:5px;
    z-index:2;
    line-height:24px;
    font-size: 14px;	font-weight: 500; color:#ffffff;
  }
}

// PRODUCTS DESK

.row {

  text-align:center;

  .product {
    min-width: 250px;
    height: 380px;
    margin: 15px 5px;;
    // border: 1px solid #DAD7D4;
    background-color: #ffffff;
    box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.15);
    border-radius: 4px;
    padding-top:10px;

    img {
      max-width:230px!important;
      max-height:200px!important;
    }

    .imgContainer {
      position:relative;
      width:250px!important;
      height:200px!important;
      text-align: center;
      line-height: 200px;
      vertical-align: middle;
      margin: 10px auto;
    }

    .productName {
      color: #312922;
      font-size: 16px;
      font-weight: 500;
      padding: 0 5px;
      min-height:48px;
      margin-top:10px;
      text-transform: capitalize;
    }

    .productFrom {
      font-size: 18px;
      color: rgb(99, 96, 92);
      padding:0 5px;
      text-decoration: line-through;
      height:24px;
      width:110px;
      text-align:right;
    }

    .productPrice {
      font-size: 20px;
      font-weight: 500;
      min-width:120px;
      text-align:center;
      margin: 0 auto;
    }

    .productFrom ~ .productPrice {
      text-align:left;
    }
    

    .addToCart {
      width: 150px;
      height:38px;
      text-align:center;
      border:1px solid;
      padding:5px;
      border-radius:4px;
      font-size:16px;
      font-weight:500;
      color:#ffffff;
      margin:10px auto;
      cursor:pointer;
    }

    .productFooter {
      margin-top:10px;
    }

    .priceContainer {
      width:250px;
      min-height:24px;
      display:inline-flex;
    }

    .buttonContainer {
      width:250px;
      margin: 0 auto;
    }

    .plusConatiner {
      margin: 10px auto;
      text-align:center;
      .plus-bt {
        font-size:25px;
      }
      .plus-qtd {
        font-size:18px;
        width:50px;
        font-weight: 500;
      }
    }
  }

  .promoLabel {
    border-radius:4px;
    height:24px;
    width:74px;
    position:absolute;
    top:-5px;
    left:5px;
    z-index:2;
    line-height:24px;
    font-size: 14px;	font-weight: 500; color:#ffffff;
  }
}
</style>
